import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api, imgUrl } from "@/lib/api";

export function BrandSlider() {
  const { data = [] } = useQuery({ queryKey: ["brands"], queryFn: () => api.get("/brands").then((r) => r.data) });
  const brands = data.filter((b) => b.show_in_slider && b.logo);
  if (!brands.length) return null;
  let row = brands;
  while (row.length < 8) row = [...row, ...brands];
  const loop = [...row, ...row];
  return (
    <section className="bg-white border-b-2 border-neutral-900 py-8 sm:py-10" data-testid="brand-slider">
      <div className="container-x flex items-end justify-between gap-4 mb-5">
        <div>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[var(--bk-orange)]">Brand Resmi</span>
          <h2 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight">Our Brands</h2>
        </div>
        <Link to="/katalog" className="text-sm font-semibold underline underline-offset-4 hover:text-[var(--bk-orange)]" data-testid="brand-slider-all">Lihat semua produk</Link>
      </div>
      <div className="brand-marquee relative overflow-hidden">
        <div className="brand-track flex w-max gap-4 sm:gap-6 py-2" style={{ animationDuration: `${row.length * 3.5}s` }}>
          {loop.map((b, i) => (
            <Link
              key={`${b.id}-${i}`}
              to={`/katalog?brand=${encodeURIComponent(b.name)}`}
              aria-hidden={i >= row.length}
              tabIndex={i >= row.length ? -1 : 0}
              data-testid={i < brands.length ? `brand-logo-${b.slug}` : undefined}
              title={`Produk ${b.name}`}
              className="group shrink-0 w-36 h-24 sm:w-48 sm:h-28 rounded-2xl border-2 border-neutral-900 bg-white flex items-center justify-center overflow-hidden p-3 shadow-[4px_4px_0_#111] hover:-translate-y-1 hover:shadow-[6px_8px_0_var(--bk-orange)] transition-[transform,box-shadow] duration-300"
            >
              <img src={imgUrl(b.logo)} alt={b.name} loading="lazy" className="max-h-full max-w-full object-contain group-hover:scale-105 transition-transform duration-300" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
